import { useTranslation } from 'react-i18next'
import { Button, Card, CardContent, CardHeader, CardTitle } from '@clouway/ui'
import { Clock, MapPin, X } from 'lucide-react'

import { useDateFormatter } from '@/hooks/useDateFormatter'
import type { RoutePoint } from '../types'

export function TelemetryPanel({ point, onClose }: { point: RoutePoint; onClose: () => void }) {
  const { t } = useTranslation('feature')
  const { t: tCommon } = useTranslation('common')
  const { formatDateTime } = useDateFormatter()
  const analog = point.analogResult ?? {}

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <CardTitle className="text-base">{point.speed} km/h</CardTitle>
          <span className="text-muted-foreground flex items-center gap-1 text-sm">
            <Clock className="size-4" />
            {formatDateTime(point.time)}
          </span>
          <Button size="icon" variant="ghost" aria-label={tCommon('ui.button.cancel')} onClick={onClose}>
            <X className="size-4" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="flex flex-col gap-2 text-sm">
        <div className="flex items-center justify-between">
          <span>{point.dist} m</span>
          <span className="text-muted-foreground flex items-center gap-1">
            <MapPin className="size-4" />
            {point.lat}, {point.long}
          </span>
        </div>

        {Object.keys(analog).length > 0 && (
          <>
            <h3 className="mt-2 font-semibold">{t('trackingObjects.status.analogReadings')}</h3>
            {Object.entries(analog).map(([key, reading]) => (
              <div key={key} className="flex justify-between">
                <span>{t(`trackingObjects.config.analogInputTypes.${key}` as 'trackingObjects.config.analogInputTypes.rpm')}</span>
                <span>
                  {reading.value}{' '}
                  {t(`trackingObjects.config.analogInputUnits.${reading.unit}` as 'trackingObjects.config.analogInputUnits.litre')}
                </span>
              </div>
            ))}
          </>
        )}
      </CardContent>
    </Card>
  )
}
